import { getLanguage } from "@home/utils/common";

export function uniqueArray<T>(arr: Array<T>) {
  return Array.from(new Set(arr));
}

export const  getAllLanguageValue = (
  originalOptions: Array<{ children: any[]; value: string; }>,
) => {
  const regions: Array<string> = [];
  const markets = (originalOptions || []).reduce(
    (pre: any[], cur: { children: any[]; value: string; }) => {
      regions.push(cur.value);
      pre.push(...cur.children.map((item: { value: any; }) => item.value));
      return pre;
    },
    [],
  );

  return {
    regions: uniqueArray(regions),
    markets: uniqueArray(markets),
  };
};

/**
 * 格式化语言选项
 * 
 * @param {Array} data - 语言选项数据数组，每个元素包含 code、name_cn 和 name_en 属性。
 * @param {boolean} isEn - 指示是否使用英文名称。如果为 true，则使用 name_en，否则使用 name_cn。
 * @returns {Array} 返回格式化后的语言选项数组，每个元素包含 value 和 label 属性。
 */
export const formatLanguageList = (data: Array<any>, isEn: boolean): Array<any> => {
  let globalOption: any = null;
  const otherOptions: Array<any> = [];
  data?.forEach((item) => {
    const { code, name_cn, name_en } = item || {};
    const option = {
      value: code,
      text: isEn ? name_en : name_cn,
    };
    if (code.toLowerCase() === 'global') {
      globalOption = { ...option, disabled: true };
    } else {
      otherOptions.push(option);
    }
  });
  if (globalOption) {
    otherOptions.unshift(globalOption);
  }
  return otherOptions;
};

/**
 * 格式化语言选项
 * 
 * @param {Array} data - 语言选项数据数组，每个元素包含 code、name_cn 和 name_en 属性。
 * @param {boolean} isEn - 指示是否使用英文名称。如果为 true，则使用 name_en，否则使用 name_cn。
 * @returns {Array} 返回格式化后的语言选项数组，每个元素包含 value 和 label 属性。
 */
export const formatGameList = (data: Array<any>, isEn: boolean): Array<any> => data?.map((item) => {
  const { unified_edition_id, name_cn, name_en, cover } = item || {};
  return {
    value: unified_edition_id,
    text: isEn ? name_en : name_cn,
    icon: cover,
  };
});

/**
 * 格式化数据，将输入数据转换为以指定键为索引的对象。
 * 
 * @param {Array} data - 输入的数据数组。
 * @param {string} key - 用于索引的键。
 * @param {boolean} isEn - 指示是否使用英文名称。
 * @returns {Object} 格式化后的数据对象，键为指定的 key，值为包含名称和封面信息的对象。
 */
export const formatListData = (data: Array<any>, key: string, isEn: boolean) => data.reduce((acc, item) => {
  acc[item?.[key]] = {
    [key]: item?.[key],
    name: getLanguage(isEn, item.name_en, item.name_cn),
    cover: item.cover || ''
  };
  return acc;
}, {});